import React from "react";
import Grid from "@material-ui/core/Grid";
import {toGermanFormat} from "../../../../../../utils/numberFormater";
import WarningTooltip from "../../../../../../components/WarningTooltip";
import InputFormElement, {
  CurrencyNumberFormat
} from "../../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import {MODEL_PORTFOLIO_WEIGHT} from "../../../../../Modelportfolios/Create/constants";
import {AVG_PTF_INFO} from "../../../../../RiskProfiling/constants";


/**
 * Renders the portfolio header section:
 * - Weighted portfolio risk (SRRI) for Anlageberatung
 * - Total portfolio value input for new virtual portfolios
 */
const PortfolioHeader = ({
  classes,
  isAnlageberatung,
  isVirtual,
  isNewVirtual,
  averageSrriValue,
  portfolio,
  handleNewVirtualPortfolioValueTotalChange,
}) => {
  const showSrri = isAnlageberatung;
  const showTotalInput = isVirtual && isNewVirtual;

  if (!showSrri && !showTotalInput) return null;

  return (
    <Grid item xs={12}>
      <Grid container alignItems="center">
        {showSrri && (
          <Grid item xs={12} md={4} alignItems={"center"} data-id={'portfolio-avg-sri'}>
            <b>Gewichtetes Portfoliorisiko: {toGermanFormat(averageSrriValue)}</b><WarningTooltip title={AVG_PTF_INFO} />
          </Grid>
        )}
        {showTotalInput && (
          <Grid item style={{marginLeft: 'auto', display: 'flex', alignItems: 'baseline'}} data-id={'portfolio-total-amount-input-container'}>
            <span style={{marginRight: 10, display: 'contents'}}>
              Musterdepotwert:{' '}
              <WarningTooltip title={"Definieren Sie hier das gesamte initiale Anlagevolumen Ihres Musterdepots. Verteilen Sie dies anschließend über die Gewichtung oder geben Sie die konkreten Bruttobeträge für die einzelnen Produkte ein."}/>
            </span>
            <InputFormElement
              inputComponent={CurrencyNumberFormat}
              value={portfolio.portfolioValueTotal}
              onChange={handleNewVirtualPortfolioValueTotalChange}
              disabled={portfolio.transactionsWeightType == MODEL_PORTFOLIO_WEIGHT.AUTO}
              custom_classes={{
                inputRoot: classes.totalAmountInputRoot
              }}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default PortfolioHeader;
